export const AppAction = {
  UpdateConfig: 'UpdateConfig',
  UpdateMe: 'UpdateMe',
  UpdateSettings: 'UpdateSettings',
  UpdateImageQueuePatientStatus: 'UpdateImageQueuePatientStatus',
  UpdatePage: 'UpdatePage',
  UpdatePatient: 'UpdatePatient',
  UpdatePatientId: 'UpdatePatientId',
  UpdateSystemSettings: 'UpdateSystemSettings',
  ShowOverlay: 'ShowOverlay',
  VerifyDisabled: 'VerifyDisabled',
  AuthorizePage: 'AuthorizePage'
} as const;

export type AppAction = ValueOf<typeof AppAction>;